import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { SharedFavoritesContent } from "../components/FavoritesContent/SharedFavoritesContent";
import {
    firstBlockOverlapsNav,
    isOverlapBlockType,
} from "../components/HeaderNav/overlap";
import { PageSkeleton } from "../components/PageSkeleton";
import { toolboxComponents } from "../components/PageSkeleton/Toolbox";

import styles from "../styles/favorites-page.module.scss";

export const Template = (props: templates.SharedFavoritesPageTemplate) => (
    <PageSkeleton
        {...props.page}
        overlapNav={firstBlockOverlapsNav(
            props.page.body.value.slice(0, 1).find(isOverlapBlockType),
        )}
        rootClassName={styles.favoritesPage}
    >
        <StreamField
            tagName={React.Fragment}
            value={props.page.body.value}
            components={{
                ...toolboxComponents,
                shared_favorites_content: ({ value }) => (
                    <SharedFavoritesContent
                        value={value}
                        products={props.products}
                        gridPromos={props.page.grid_promos.value}
                    />
                ),
            }}
        />
    </PageSkeleton>
);
